module.exports = __webpack_public_path__ + "img/header-memoireRingsRosegold.91afb9f.jpg";